import { COOKIE_DOMAIN } from "../const"
import type { AuthAction, Locale, SmmAuthConfig } from "../types"
import { clearAuthCookies, getCookie, setCookie } from "./cookies"
import { assertSafeReturnUrl, buildLoginRedirectUrl } from "./return-url"

export type SetAuthCookieOptions = {
  remember?: boolean
  temporary?: boolean
}

export const validateReturnUrl = (returnUrl: string | undefined, baseUrl: string): string => {
  return assertSafeReturnUrl(returnUrl, baseUrl)
}

export const buildLoginUrl = ({
  userCenterUrl,
  locale,
  action = "login",
  returnUrl,
}: {
  userCenterUrl: string
  locale: Locale | string
  action?: AuthAction
  returnUrl: string
}): string => {
  return buildLoginRedirectUrl(userCenterUrl, locale, action, returnUrl)
}

export const setAuthCookie = (config: SmmAuthConfig, token: string, options: SetAuthCookieOptions = {}): void => {
  setCookie(options.temporary ? config.temporaryCookieName : config.cookieName, token, {
    domain: COOKIE_DOMAIN,
    days: options.remember ? 60 : undefined,
  })
}

export const clearAuthCookie = (config: SmmAuthConfig): void => {
  clearAuthCookies(config.cookieName, config.temporaryCookieName, COOKIE_DOMAIN)
}

export const getAuthToken = (config: Pick<SmmAuthConfig, "cookieName">): string | null => {
  return getCookie(config.cookieName)
}
